import { Link } from 'react-router-dom';

const heroImage = 'https://readdy.ai/api/search-image?query=A%20stunning%20artistic%20manga%20themed%20background%20with%20vibrant%20warm%20orange%20and%20coral%20gradients%2C%20abstract%20comic%20panel%20layouts%2C%20speed%20lines%2C%20ink%20splashes%2C%20Japanese%20manga%20aesthetic%2C%20dynamic%20energy%2C%20modern%20clean%20design%2C%20soft%20glowing%20highlights%2C%20professional%20illustration%2C%20no%20characters%2C%20abstract%20composition&width=1800&height=900&seq=hero-manga-2026&orientation=landscape';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src={heroImage}
        alt="色漫屋 - 海量漫画资源一站畅读"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/50 via-foreground-950/30 to-foreground-950/60"></div>
      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading text-background-50 mb-4 leading-tight">
          海量漫画，一站畅读
        </h1>
        <p className="text-sm md:text-lg text-background-200 max-w-2xl leading-relaxed mb-8">
          汇聚热血、恋爱、悬疑、搞笑等多种题材漫画，更新快速，分类清晰，免费在线阅读与下载，漫画迷不可错过的追漫首选平台
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3">
          <Link
            to="/category/rexue"
            className="px-8 py-3 bg-primary-500 text-background-50 rounded-full text-sm md:text-base font-semibold hover:bg-primary-600 transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            开始阅读
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 border-2 border-background-50/30 text-background-50 rounded-full text-sm md:text-base font-medium hover:bg-background-50/10 transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}